<template>
  <v-container fluid class="home-dashboard pa-4">
    <div class="dashboard-header mb-4">
      <div>
        <div class="dashboard-title">Dashboard</div>
        <div class="dashboard-subtitle">
          Here is what is happening today.
        </div>
      </div>

      <div class="dashboard-actions">
        <v-btn small rounded outlined @click="$router.push('/customer/home')">
          <v-icon left small>mdi-account-group</v-icon>
          Customers
        </v-btn>

        <v-btn
          small
          rounded
          color="primary"
          dark
          @click="$router.push('/invoice/create')"
        >
          <v-icon left small>mdi-plus</v-icon>
          New Invoice
        </v-btn>
      </div>
    </div>

    <v-row dense class="mb-1">
      <v-col cols="12" sm="6" md="3" v-if="checkRightStatus(60)">
        <CustomerCount />
      </v-col>

      <v-col cols="12" sm="6" md="3" v-if="checkRightStatus(60)">
        <InvoiceCount />
      </v-col>

      <v-col cols="12" sm="6" md="3" v-if="checkRightStatus(60)">
        <SignUpCount />
      </v-col>

      <v-col cols="12" sm="6" md="3" v-if="checkRightStatus(60)">
        <OutstandingMoney />
      </v-col>
    </v-row>

    <div v-if="checkRightStatus(46)" class="dashboard-section">
      <SaleCount />
    </div>

    <div class="dashboard-masonry">
      <div class="dashboard-stack">
        <div v-if="checkRightStatus(56)" class="dashboard-section">
          <PendingOrder />
        </div>

        <div class="dashboard-section">
          <DeliveryCalendar />
        </div>

        <div v-if="checkRightStatus(57)" class="dashboard-section">
          <InvoiceBySalesRep />
        </div>
      </div>

      <div class="dashboard-stack">
        <div v-if="checkRightStatus(59)" class="dashboard-section">
          <ReOrderList />
        </div>

        <div v-if="checkRightStatus(58)" class="dashboard-section">
          <TodayPayment />
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import CustomerCount from "@/modules/Customer/components/Tile/Count";
import SignUpCount from "@/modules/Customer/components/Tile/SignUpCount";
import InvoiceCount from "@/modules/Customer/components/Tile/InvoiceCount";
import OutstandingMoney from "@/modules/Customer/components/Tile/OutstandingMoney";
import PendingOrder from "@/modules/Home/components/PendingOrder";
import DeliveryCalendar from "@/modules/Home/components/DeliveryCalendar";
import ReOrderList from "@/modules/Home/components/ReOrderList.vue";
import TodayPayment from "@/modules/Customer/Payment/Table/TodayPayment";
import InvoiceBySalesRep from "@/modules/Invoice/components/InvoiceBySalesRep";
import SaleCount from "@/modules/Home/components/Charts/SaleCount";
import RegisterStoreModule from "@/mixins/RegisterStoreModule";

import { mapGetters } from "vuex";

export default {
  name: "home",

  mixins: [RegisterStoreModule],

  components: {
    CustomerCount,
    PendingOrder,
    SaleCount,
    TodayPayment,
    InvoiceCount,
    SignUpCount,
    OutstandingMoney,
    InvoiceBySalesRep,
    ReOrderList,
    DeliveryCalendar,
  },

  created() {
    document.title = "smplsale - Home";
  },

  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
};
</script>

<style scoped>
.home-dashboard {
  background: #f8fafc;
  min-height: 100%;
}

.dashboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.dashboard-title {
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
}

.dashboard-subtitle {
  font-size: 14px;
  color: #64748b;
  margin-top: 2px;
}

.dashboard-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dashboard-section {
  margin-bottom: 12px;
}

.dashboard-masonry {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
  align-items: start;
}

.dashboard-stack {
  display: flex;
  flex-direction: column;
}

@media (max-width: 960px) {
  .dashboard-masonry {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .home-dashboard {
    padding: 10px !important;
  }

  .dashboard-title {
    font-size: 24px;
  }

  .dashboard-actions {
    width: 100%;
  }

  .dashboard-actions .v-btn {
    flex: 1;
  }
}
</style>